module.exports = __webpack_public_path__ + "media/images/weather/330_day-a82360d0af0fb0d78d428678b9a80b56.png";